module.exports = __webpack_public_path__ + "static/media/img-3.b458a270.jpg";